import React from 'react';

const SearchBtn = ({ setSearchTerm }) => {
    return (
        <div className='flex items-center h-10 border outline-gray-300 border-gray-300 rounded w-full lg:w-80 bg-gray-100'>
            <input type="text" className='h-full w-4/5 outline-none [background:none] pl-4 text-xs xsm:text-sm' placeholder='search...'
                onChange={(e) => setSearchTerm(e.target.value)} />
            <a href="#" className=' w-1/5 block text-center text-sm xsm:text-base text-gray-600'>
                <i className="fa-solid fa-magnifying-glass"></i>
            </a>
        </div>
    )
}

export default SearchBtn;